import * as PropTypes from 'prop-types';
import React from 'react';
import Div from './div';
import MDAndLargerDiv from './md.and.larger.div';
import XSAndSMDiv from './xs.and.sm.div';

const StackingButtons = props => {
    return <>
        <MDAndLargerDiv>
            <Div isRow={true}>
                <Div
                    cols={12}
                    paddingBottom={1} paddingTopSM={1} paddingTopMD={2} paddingTopLG={3} paddingTopXL={4}
                >
                    {props.button1}
                    <span style={{padding: 4}}></span>
                    {props.button2}
                </Div>
            </Div>
        </MDAndLargerDiv>
        <XSAndSMDiv>
            <Div
                isRow={true}
                marginTop={1}
                className="stacked-button"
            >
                <Div cols={12}>
                    {props.button1}
                </Div>
            </Div>
            <Div
                isRow={true}
                marginTop={1}
                className="stacked-button"
            >
                <Div cols={12}>
                    {props.button2}
                </Div>
            </Div>
        </XSAndSMDiv>
    </>;
};

StackingButtons.propTypes = {
    button1: PropTypes.element.isRequired,
    button2: PropTypes.element.isRequired,
};

export default StackingButtons;